module.exports = __webpack_public_path__ + "img/img38.76f033c8.png";